var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.uiFlags.isFetching)?_c('div',{staticClass:"loader"},[_c('spinner')],1):_c('div',{staticClass:"column content-box changelog-wrapper overflow-auto",domProps:{"innerHTML":_vm._s(_vm.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }